import { ReactNode } from 'react';
import { useRouter } from 'next/router';
import { Box } from '@cbhq/cds-web/layout';
import { Spinner } from '@cbhq/cds-web/loaders/Spinner';

import { FullscreenError } from ':support/components/FullscreenError';
import { isLocal } from ':support/config';
import { setRedirectUri } from ':support/utils/session-utils/redirectUriStorage';

type SessionProviderContentProps = {
  isLoading: boolean;
  errorStatus?: number;
  isLoggedIn: boolean;
  children: ReactNode;
  fallback: ReactNode;
  disableAuth?: boolean;
};

// eslint-disable-next-line
export function SessionProviderContent({
  isLoading,
  errorStatus,
  isLoggedIn,
  children,
  fallback,
  disableAuth,
}: SessionProviderContentProps) {
  const router = useRouter();

  if (errorStatus) {
    return <FullscreenError />;
  }

  if (isLoading) {
    return (
      <Box height="100vh" alignItems="center" background="bg" justifyContent="center">
        <Spinner size={8} color="fgPrimary" />
      </Box>
    );
  }

  if (isLoggedIn) {
    return children;
  }

  if (isLocal() && disableAuth) {
    return children;
  }

  // Store redirect path when not authenticated
  if (typeof window !== 'undefined' && router.pathname !== '/') {
    setRedirectUri(router.asPath);
  }

  return fallback;
}
